import { SetInitialStateFacade } from '../models/set-initial-state.facade';

export function setInitialStoreState(facade: SetInitialStateFacade): boolean {
  facade.setInitialState();

  return true;
}
